export enum IMunicipalityTab {
    residence,
    residenceRequest,
    roleGroup
}

export interface IMunicipality {
    municipalityId: number;
    municipalityCode: string;
    municipalityName: string;
}

export interface IDistrict {
    municipality: IMunicipality;
    districtId: number;
    districtCode: string;
    districtName: string;
}

export interface IMunicipalityDistrict {
    municipalityId: number;
    districtId?: number;
}